import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/Login";import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset your password" subtitle="Enter your email and we'll send a reset link."
      footer={<>Remembered it? <Link to="/login" className="font-semibold text-slate-900 underline">Sign in</Link></>}>
      {sent ? (
        <p className="text-sm text-slate-600" data-testid="forgot-sent">
          If an account with that email exists, a password reset link has been sent. The link expires in 30 minutes and can be used once.
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email-input" className="mt-1.5" placeholder="you@example.com" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="forgot-submit-btn" className="w-full bg-slate-900 hover:bg-slate-800">
            {loading ? "Sending…" : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
